import styled, { css } from 'styled-components'

/*
  Title Trailer (overall) Styles
*/

const VIEWPORT = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
}

type Props = {
  opacity?
  height?
  overflow?
  top?
  left?
  width?
  tileHeight?
  initialOpacity?
  trailer?
  paddingBottom?
  forceRerender?
}

export const TrailerContainer = styled.div`
  position: relative;
  width: 100%;
  z-index: 5;
`

export const CloudTileContainer = styled.div`
  position: relative;
  z-index: 10;
`

export const BlackGradient = styled.div<Props>`
  position: absolute;
  width: 100%;
  height: ${(props) => (props.height ? props.height + 'px' : '100%')};
  z-index: 10;
  top: 0;
  pointer-events: none;
  opacity: 1;
  display: flex;
  background: linear-gradient(
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.7),
    rgba(0, 0, 0, 0.9),
    rgba(0, 0, 0, 0.7),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0)
  );
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.trailer &&
    css`
      background: linear-gradient(
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.9),
        rgba(0, 0, 0, 1),
        rgba(0, 0, 0, 0.9),
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0)
      );
      opacity: 0;
    `}
`

export const MainTextContainer = styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 11;
  top: 0;
`
/*
  Exploding Tiles Styles
*/

export const Container = styled.div<Props>`
  background: black;
  height: ${(props) => props.height}px;
  overflow: ${(props) => props.overflow};
`

export const TileContainer = styled.div<Props>`
  position: relative;
  height: 100%;
  overflow: hidden;
  padding-bottom: ${(props) => props.paddingBottom}px;
  top: ${(props) => props.top}px;
`

export const CloudTextArea = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  z-index: 16;
`

export const TextSpacer = styled.div`
  visibility: hidden;
`

export const VisibleCloudText = styled.div<Props>`
  position: absolute;
  opacity: ${(props) => props.opacity};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

export const CenterCloudDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`

export const CenterButton = styled.div`
  display: flex;
  justify-content: center;
`

export const Tile = styled.div<Props>`
  position: absolute;
  width: ${(props) => props.width}px;
  margin-left: auto;
  margin-right: auto;
  object-fit: cover;
  overflow: hidden;
  border-radius: 4px;
  left: ${(props) => props.left}px;
  height: ${(props) => props.height}px;
  top: ${(props) => props.top}px;
`

/*
  Video Trailer Styles
*/

export const TrailerImage = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  width: 83.2%;
  height: 76.3%;
  display: flex;
  top: 1%;
`

export const VideoContainer = styled.div<Props>`
  position: relative;
  width: 100%;
  height: ${(props) => (props.height === 0 ? '100vh' : props.height + 'px')};
  overflow: hidden;
`
type VideoProps = {
  loading?
}
export const Video = styled.video<VideoProps>`
  object-fit: cover;
`

export const CaretContainer = styled.div<Props>`
  bottom: ${(props) => props.tileHeight}px;
  position: static;
  margin-top: 100px;
  opacity: 1;
  transition: opacity 0.5s, margin-top 0.5s;

  @media (max-height: 600px) {
    margin-top: 20px;
    opacity: 0;
  }
`

export const StreamingServiceContainer = styled.div<Props>`
  position: absolute;
  margin-left: auto;
  margin-right: 0;
  @media only screen and (min-width: ${VIEWPORT.xs}) {
    bottom: ${(props) => props.tileHeight / 2}px;
    right: 20px;
  }
  @media only screen and (min-width: ${VIEWPORT.sm}) {
    bottom: ${(props) => props.tileHeight}px;
    right: 50px;
  }
  @media only screen and (min-width: ${VIEWPORT.md}) {
    bottom: ${(props) => props.tileHeight}px;
    right: 100px;
  }
`

export const StreamingLogo = styled.img`
  width: 7vh;
  height: 7vh;

  @media only screen and (min-width: ${VIEWPORT.xs}) {
    max-height: 80px;
  }
`

export const ZeroOpacity = styled.div<Props>`
  opacity: ${(props) => props.opacity};
`
export const MainTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

/*
  Framed Trailer Styles
*/

export const FrameContainer = styled.div<Props>`
  position: relative;
  width: 1200px;
  height: ${(props) => props.height}px;
  display: flex;
  justify-content: center;
`

export const TVFrameOffsetContainer = styled.div<Props>`
  position: absolute;
  width: 100%;
  top: ${(props) => props.top}px;
  z-index: 1000;
`

export const TVFrameContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const MobileFrameOffsetContainer = styled.div<Props>`
  width: 95%;
  position: absolute;
  top: ${(props) => props.top}px;
  z-index: 1000;
  margin: auto;
`

export const FramedTrailer = styled.div`
  position: absolute;
  background: black;
  width: 83.4%;
  height: 84.5%;
  margin-top: 2%;
`

export const TileImageContainer = styled.div<Props>`
  position: absolute;
  display: inline-block;
  border-radius: 10px;
  width: ${(props) => props.width};
  aspect-ratio: 1.777/1;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  overflow: hidden;
  z-index: 1000;
`

export const CenterTV = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`

export const MenuPosition = styled.div`
  position: absolute;
  left: 8.25%;
  width: 83.4%;
  top: 3.3%;
  z-index: 9432;
`

export const CurrentTrailerTVPos = styled.div<Props>`
  position: absolute;
  left: ${(props) => props.left};
  right: auto;
  width: 40%;
  height: 100%;
  top: ${(props) => props.top};
  z-index: 100;
`

export const OverflowContainer = styled.div`
  position: absolute;
  width: 83.3%;
  height: 100%;
  overflow: hidden;
`

export const ImageContainer = styled.div`
  position: relative;
  left: 6%;
  height: 100%;
`

export const TileText = styled.div<Props>`
  position: absolute;
  display: inline-block;
  border-radius: 10px;
  width: ${(props) => props.width};
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  overflow: hidden;
  z-index: 1000;
  color: white;
`

export const SmallTileImageContainer = styled.div<Props>`
  position: absolute;
  display: inline-block;
  border-radius: 10px;
  width: 30%;
  aspect-ratio: 1.777/1;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  overflow: hidden;
  z-index: 1000;
`

export const TVGradient = styled.div`
  position: absolute;
  width: 83.5%;
  height: 89.3%;
  z-index: 5;
  top: -0.7%;
  display: flex;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0) 70.35%);
  align-items: center;
  justify-content: center;
`

export const TVLowerImage = styled.div`
  position: absolute;
  width: 20.2%;
  bottom: -10.5%;
  right: 0;
  left: 0;
  margin: auto;
  z-index: 1002;
`
